import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import Header from "../components/Header";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Payment() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch {}
      if (tries++ < 8) setTimeout(poll, 1800); else setStatus("pending");
    };
    poll();
  }, [sid, refresh]);

  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      <Header variant="list" />
      <section className="pt-40 pb-20 px-6 max-w-lg mx-auto text-center">
        {status === "checking" && <><Loader2 className="mx-auto text-gold animate-spin" size={40} /><p className="font-headline italic text-xl mt-6">Confirming your membership…</p></>}
        {status === "paid" && (<>
          <CheckCircle2 className="mx-auto text-gold" size={48} data-testid="payment-success" />
          <h1 className="font-display text-3xl tracking-tight mt-6">WELCOME TO THE LIST</h1>
          <p className="font-headline italic text-ivory/70 mt-3">Your membership is active. The leverage begins now.</p>
          <Link to="/list/dashboard" className="btn-lux mt-8 inline-block bg-gold text-obsidian hover:bg-ivory">Enter Dashboard</Link>
        </>)}
        {(status === "pending" || status === "error") && (<>
          <p className="font-headline italic text-xl mt-6">{status === "pending" ? "Still processing — check your dashboard shortly." : "We couldn't confirm this payment."}</p>
          <Link to="/list#the-list" className="btn-lux mt-8 inline-block bg-transparent text-ivory hover:bg-white/5">Back to The LIST</Link>
        </>)}
      </section>
    </div>
  );
}
